import { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "./lib/lang";
import { initLenis } from "./lib/smooth";
import { Preloader } from "./components/Preloader";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Works } from "./components/Works";
import { MotionLab } from "./components/MotionLab";
import { Tutorials } from "./components/Tutorials";
import { Photography } from "./components/Photography";
import { SocialMedia } from "./components/SocialMedia";
import { Resume } from "./components/Resume";
import { ProjectModal } from "./components/ProjectModal";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import Inbox from "./pages/Inbox";

const Home = () => {
  const [ready, setReady] = useState(false);
  const [project, setProject] = useState(null);
  const close = useCallback(() => setProject(null), []);

  useEffect(() => {
    const destroy = initLenis();
    return () => destroy();
  }, []);

  return (
    <>
      <Preloader onDone={() => setReady(true)} />
      <Nav />
      <main>
        <Hero ready={ready} />
        <Marquee />
        <Works onOpen={setProject} />
        <SocialMedia onOpen={setProject} />
        <MotionLab />
        <Tutorials />
        <Photography />
        <About />
        <Resume />
        <Services />
        <Contact />
      </main>
      <Footer />
      <ProjectModal project={project} onClose={close} />
    </>
  );
};

function App() {
  return (
    <LangProvider>
      <div className="grain">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/inbox" element={<Inbox />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#121215", border: "1px solid rgba(255,255,255,0.12)", color: "#f4f4f5" } }} />
      </div>
    </LangProvider>
  );
}

export default App;
